export { provider_company_parts, provider_contact_parts, provider_bank_parts, provider_po_parts };


const provider_po_parts = {
  EKORG: { label: "Purchasing Organization", list: "purchasingOrganisations", listKeys: ["EKORG", "EKOTX"] },
  PURCH_CURR: { label: "Purchasing Currency", list: "purchasingCurrency", listKeys: ["WAERS", "LTEXT"] },
  PURCH_INCO1: { label: "Incoterms 1", list: "purchasingIncoTerms", listKeys: ["INCO1", "BEZEI"] },
  PURCH_INCO2: { label: "Incoterms 2" },
  PURCH_PTERMS: { label: "Payment Terms", list: "purchasingPaymentTerms", listKeys: ["ZTERM", "TEXT1"] },
  PURCH_MINBW: { label: "Minimum Value" },
  PURCH_SALESPERS: { label: "Salesperson" },
  PURCH_TEL: { label: "Telephone" },
  PURCH_SHIPCOND: { label: "Shipping Conditions", list: "purchasingShippingConditions", listKeys: ["VSBED", "VTEXT"] },
  PURCH_GROUP: { label: "Purchasing Group" }
}
const provider_bank_parts = {
  BANK_NAME: { label: "Bank", required: true },
  BANK_COUNTRY: {
    label: "Country",
    list: "countryDropdownValues",
    listKeys: ["LAND1", "LANDX"],
    required: true
  },
  BANK_CITY: { label: "City" },
  BANK_STREET: { label: "Street" },
  BANK_HOUSE_NO: { label: "House Number" },
  BANK_IBAN: { label: "IBAN Number" },
  BANK_SWIFT: { label: "Swift-Code or ABA" },
  BANK_ACT_NAME: { label: "Account Name" },
  BANK_ACCOUNT: { label: "Account Number", required: true },
  BANK_CODE: { label: "Bank Code", required: true },
  BANK_BRANCH: { label: "Branch Code" },
  BANK_PARTNER_TYP: { label: "Partner Bank Type", required: true },
  BANK_REFERENCE: { label: "Reference details" },
  BANK_CONTROL_KEY: { label: "Bank Control Key" }
}


const provider_contact_parts = {
  CP_CONTACTNO: { label: "contactno", hidden: true },
  CP_FIRSTNAME: { label: "Firstname", required: true },
  CP_LASTNAME: { label: "Lastname", required: true },
  CP_TELF: { label: "Tel" },
  CP_MOBIL: { label: "Mobile" },
  CP_EMAIL: { label: "Email", required: true },
  CP_FAX: { label: "Fax" },
  CP_FUNC: { label: "Function/Job Title" },
  CP_DEPT: { label: "Department" },

}

const provider_company_parts = {
  COMP_NAME: { label: "Name", required: true, maxLength: 35 },
  COMP_NAME2: { label: "Name 2", maxLength: 35 },
  COMP_NAME3: { label: "Name 3", maxLength: 35 },
  COMP_NAME4: { label: "Name 4", maxLength: 35 },
  COMP_STREET: { label: "Street", required: true, maxLength: 60 },
  COMP_HOUSE_NO: { label: "House Number", maxLength: 10 },
  COMP_STREET2: { label: "Street 2", maxLength: 40 },
  COMP_STREET3: { label: "Street 3", maxLength: 40 },
  COMP_STREET4: { label: "Street 4", maxLength: 40 },
  COMP_STREET5: { label: "Street 5", maxLength: 40 },
  COMP_CITY: { label: "City", required: true, maxLength: 35 },
  COMP_PSTLZ: { label: "Zip Code", required: true, maxLength: 10 },
  COMP_COUNTRY: {
    label: "Country",
    list: "countryDropdownValues",
    listKeys: ["LAND1", "LANDX"],
    required: true,
    maxLength: 3
  },
  COMP_REGION: {
    label: "Region",
    list: "regionsForCountry",
    listKeys: ["BLAND", "BEZEI"],
    alternativeText:
      "Please select country first / no regions for country found",
    maxLength: 3
  },

  COMP_EMAIL: { label: "Email Address", maxLength: 240 },
  COMP_RECON_ACCT: {
    label: "Reconciliation Account",
    list: "reconAcct",
    listKeys: ["SAKNR", "TXT50"],
    required: true,
    maxLength: 10
  },
  COMP_VAT_REG: { label: "VAT Registration Number", maxLength: 20 },
  COMP_REG_NO: { label: "Company Registration Number", maxLength: 30 },

  COMP_TYPE: { label: "Business Unit/Type", maxLength: 30 },
  COMP_PMETHOD: {
    label: "Payment Method",
    list: "paymentMethod",
    listKeys: ["ZLSCH", "TEXT1"],
    required: true,
    maxLength: 1
  },
  COMP_MEMO: { label: "Account Memo", maxLength: 30 },
  COMP_CLERK: { label: "Clerk's Internet", maxLength: 130 },
  COMP_CLERK_TEL: { label: "Clerk’s Telephone No.", maxLength: 50 },
  COMP_PTERMS: {
    label: "Payment Terms (Company)",
    list: "purchasingPaymentTerms",
    listKeys: ["ZTERM", "TEXT1"],
    maxLength: 4
  },
  COMP_PROF: { label: "Vendor's Profession", maxLength: 30 }
};
